function updateRelatedProductPrice(productInfo, sectionId, standPrice, moneyFormat) {
  const priceContainer =
    productInfo?.querySelector(`#price-${sectionId}`) || document.getElementById(`price-${sectionId}`);

  if (!priceContainer) return;

  priceContainer.querySelectorAll('.price-item-amount').forEach((element) => {
    const basePrice = parseInt(element.dataset.price, 10);
    if (Number.isNaN(basePrice)) return;

    if (!element.dataset.originalText) {
      element.dataset.originalText = element.textContent.trim();
    }

    if (!standPrice) {
      element.textContent = element.dataset.originalText;
      return;
    }

    element.textContent = formatRelatedMoney(basePrice + standPrice, moneyFormat);
  });
}

function formatRelatedMoney(cents, format) {
  if (window.theme?.Currency?.formatMoney) {
    return theme.Currency.formatMoney(cents, format);
  }
  return cents;
}

function syncAdditionalCheckoutItems(productInfo, selected) {
  if (!productInfo) return;

  const form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const additionalInputs = form.querySelectorAll('[name^="shopify-additional-items"]');
  additionalInputs.forEach((input) => {
    input.disabled = !selected;
  });

  const parentInput = form.querySelector('[name="shopify-additional-items[1][parent_id]"]');
  const variantId = form.querySelector('[name="id"]')?.value;
  if (parentInput && variantId) parentInput.value = variantId;

  const quantityInput = form.querySelector('[name="shopify-additional-items[1][quantity]"]');
  const quantity = productInfo.querySelector('input[name="quantity"]')?.value || 1;
  if (quantityInput) quantityInput.value = quantity;
}

function syncRelatedStandUI(productInfo, selected, source) {
  if (!productInfo) return;

  const selects = productInfo.querySelector('related-product-selects');
  if (selects && source !== 'selects') {
    const radio = selected
      ? selects.querySelector('input[data-variant-id]')
      : selects.querySelector('input[value=""]');
    if (radio && !radio.disabled) radio.checked = true;
  }

  const bundle = productInfo.querySelector('related-product-bundle');
  if (bundle && source !== 'bundle') {
    bundle.setSelected(selected);
  }

  syncAdditionalCheckoutItems(productInfo, selected);
}

if (!customElements.get('related-product-selects')) {
  customElements.define(
    'related-product-selects',
    class RelatedProductSelects extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.addEventListener('change', this.onChange);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        this.bindQuantitySync();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.variantChangeUnsubscriber?.();
        this.quantityInput?.removeEventListener('change', this.onQuantityChange);
      }

      get selectedVariantId() {
        return this.getSelectedStand().variantId;
      }

      getSelectedStand() {
        const select = this.querySelector('select');
        const option = select ? select.selectedOptions[0] : this.querySelector('input[type="radio"]:checked');

        return {
          variantId: option?.dataset?.variantId || '',
          price: parseInt(option?.dataset?.price || '0', 10) || 0,
        };
      }

      bindQuantitySync() {
        this.quantityInput = this.productInfo?.querySelector('input[name="quantity"]');
        if (!this.quantityInput) return;
        this.onQuantityChange = () => {
          syncAdditionalCheckoutItems(this.productInfo, Boolean(this.getSelectedStand().variantId));
        };
        this.quantityInput.addEventListener('change', this.onQuantityChange);
      }

      onChange(event) {
        event.stopPropagation();
        const stand = this.getSelectedStand();
        syncRelatedStandUI(this.productInfo, Boolean(stand.variantId), 'selects');
        updateRelatedProductPrice(
          this.productInfo,
          this.dataset.section,
          stand.price,
          this.dataset.moneyFormat
        );
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.dataset.section) return;
        updateRelatedProductPrice(
          this.productInfo,
          this.dataset.section,
          this.getSelectedStand().price,
          this.dataset.moneyFormat
        );
        syncAdditionalCheckoutItems(this.productInfo, Boolean(this.getSelectedStand().variantId));
      }
    }
  );
}

if (!customElements.get('related-product-bundle')) {
  customElements.define(
    'related-product-bundle',
    class RelatedProductBundle extends HTMLElement {
      constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.checkbox = this.querySelector('.related-product-bundle__checkbox');
        this.checkbox?.addEventListener('change', this.onToggle);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        this.quantityInput = this.productInfo?.querySelector('input[name="quantity"]');
        this.onQuantityChange = () => {
          syncAdditionalCheckoutItems(this.productInfo, Boolean(this.checkbox?.checked));
        };
        this.quantityInput?.addEventListener('change', this.onQuantityChange);
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.onToggle);
        this.variantChangeUnsubscriber?.();
        this.quantityInput?.removeEventListener('change', this.onQuantityChange);
      }

      get selectedVariantId() {
        return this.checkbox?.checked ? this.dataset.variantId || '' : '';
      }

      setSelected(selected) {
        if (!this.checkbox || this.checkbox.disabled) return;
        this.checkbox.checked = selected;
        this.classList.toggle('is-selected', selected);
      }

      onToggle(event) {
        event.stopPropagation();
        const selected = Boolean(this.checkbox?.checked);
        this.classList.toggle('is-selected', selected);
        syncRelatedStandUI(this.productInfo, selected, 'bundle');
        updateRelatedProductPrice(
          this.productInfo,
          this.dataset.section,
          selected ? parseInt(this.dataset.price || '0', 10) : 0,
          this.dataset.moneyFormat
        );
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.dataset.section) return;
        const variant = event.data.variant;
        if (!variant) return;

        const image = this.querySelector('[data-bundle-main-image]');
        const featuredImage = variant.featured_image?.src;
        if (image && featuredImage) {
          const joiner = featuredImage.includes('?') ? '&' : '?';
          image.src = `${featuredImage}${joiner}width=160`;
        }

        const priceEl = this.querySelector('[data-bundle-main-price]');
        if (priceEl && typeof variant.price === 'number') {
          priceEl.dataset.price = String(variant.price);
          priceEl.textContent = formatRelatedMoney(variant.price, this.dataset.moneyFormat);
        }

        const selected = Boolean(this.checkbox?.checked);
        updateRelatedProductPrice(
          this.productInfo,
          this.dataset.section,
          selected ? parseInt(this.dataset.price || '0', 10) : 0,
          this.dataset.moneyFormat
        );
        syncAdditionalCheckoutItems(this.productInfo, selected);
      }
    }
  );
}
